<template>
  <div
    :class="[
      'dlp-map-public relative',
      'w-full h-full flex flex-col bg-bianca self-start dlp-map-public--panel',
    ]">
    <dlp-list-switcher class="absolute top-6 left-6 z-10" />

    <woos-map
      :custom-options="{ gestureHandling: 'cooperative' }"
      :focus-zoom-level="DEFAULT_ZOOM_LEVEL"
      @onDlpSelect="$emit('onDlpSelect', $event)"
      @onMapDragEnd="UPDATE_SELECTED_DELIVERY_POINT(null)"
      @onMapReady="boundDlpS({ all: true, animate: false })" />

    <transition name="fade-translate-y">
      <div
        v-if="$mq.bp768 && getSelectedDeliveryPoint && !isListVisible"
        class="shadow-none absolute bottom-0 left-0 right-0 pointer-events-auto z-20">
        <transition mode="out-in" name="slide-right-to-left">
          <div
            :key="getSelectedDeliveryPoint.id"
            class="w-full p-4 bottom-0">
            <dlp-store-card
              :delivery-point="getSelectedDeliveryPoint"
              class="shadow-lg"
              closable
              @onClose="UPDATE_STORE_MARKER(null)" />
          </div>
        </transition>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { SET_QUERY } from 'Stores/types/mapMutationsTypes';
import { SEARCH_WOOS_DELIVERY_POINTS } from 'Stores/types/mapActionsTypes';

import WoosMapMixin from 'Mixins/WoosMapMixin';

import DlpCard from 'Components/deliveryPoint/DlpCard';
import WoosMap from 'Components/map/WoosMap';
import DlpStoreCard from 'Components/deliveryPoint/DlpStoreCard';
import DlpListSwitcher from 'Components/deliveryPoint/DlpListSwitcher';

import { Context } from 'PotagerLogic/Enums/Context';

import { DEFAULT_ZOOM_LEVEL } from 'Classes/utils/MapUtils';

export default {
  components: {
    DlpListSwitcher,
    DlpStoreCard,
    WoosMap,
    DlpCard,
  },

  mixins: [WoosMapMixin],

  props: {
    context: {
      type: String,
      required: false,
      default: Context.Basket,
    },
  },

  data() {
    return {
      DEFAULT_ZOOM_LEVEL,
    };
  },

  emits: ['onDlpSelect'],

  computed: {
    ...mapGetters('map', [
      'getMapCenter',
      'getSelectedDeliveryPoint',
      'isListVisible',
    ]),
  },

  methods: {
    ...mapActions('map', [
      SEARCH_WOOS_DELIVERY_POINTS,
    ])
  },

  watch: {
    getSelectedDeliveryPoint(dlp) {
      if (dlp) {
        this.SEARCH_WOOS_DELIVERY_POINTS(dlp);
      }
    },
  },

  created() {
    this.$store.commit(`map/${SET_QUERY}`, 'type:ptcyStore');
  },
};
</script>
